(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["besmart-quick-order"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-quick-order]:not([data-ready])').forEach(root=>{root.dataset.ready='true';const rows=root.querySelector('[data-quick-order-rows]'),status=root.querySelector('[data-quick-order-status]'),cartButton=root.querySelector('[data-quick-order-cart]'),cartLink=root.querySelector('[data-quick-order-cart-link]'),fileInput=root.querySelector('[data-quick-order-file]');const money=v=>new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency:root.dataset.currency}).format(Number(v||0));
const addRow=(code='',quantity=1,packaging='auto')=>{const row=document.createElement('tr');row.dataset.preferredPackaging=packaging;row.innerHTML='<td class="besmart-quick-order__code-cell"><input class="besmart-quick-order__code" maxlength="80" autocomplete="off"></td><td><div class="besmart-quick-order__multiplier"><button type="button" class="besmart-quick-order__step" data-quick-order-step="-1" aria-label="'+root.dataset.decreaseLabel+'">−</button><input class="besmart-quick-order__quantity" type="number" min="1" max="999999" step="1" aria-label="'+root.dataset.multiplierLabel+'"><button type="button" class="besmart-quick-order__step" data-quick-order-step="1" aria-label="'+root.dataset.increaseLabel+'">+</button></div></td><td class="besmart-quick-order__packaging"><select disabled><option>—</option></select></td><td class="besmart-quick-order__product">—</td><td class="besmart-quick-order__quantity-result">—</td><td class="besmart-quick-order__price">—</td><td class="besmart-quick-order__total">—</td><td><button type="button" class="besmart-quick-order__remove" aria-label="'+root.dataset.removeLabel+'">×</button></td>';row.querySelector('.besmart-quick-order__code').value=code;const multiplierInput=row.querySelector('.besmart-quick-order__quantity');multiplierInput.value=Math.max(1,parseInt(quantity,10)||1);row.querySelector('.besmart-quick-order__code').addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();lookup()}});multiplierInput.addEventListener('input',()=>renderRow(row,false));row.querySelectorAll('[data-quick-order-step]').forEach(button=>button.addEventListener('click',()=>{multiplierInput.value=Math.max(1,(parseInt(multiplierInput.value,10)||1)+parseInt(button.dataset.quickOrderStep,10));renderRow(row,false)}));row.querySelector('.besmart-quick-order__remove').addEventListener('click',()=>{row.remove();if(!rows.children.length)addRow();updateButton()});rows.append(row);return row};
const selectedOption=row=>{const match=row._item?.matches?.[0],key=row.querySelector('select').value;return match?.options?.[key]||null};
const selectedLines=()=>Array.from(rows.children).map(row=>{const o=selectedOption(row),multiplier=Math.max(1,parseInt(row.querySelector('.besmart-quick-order__quantity').value,10)||1);if(!o?.available)return null;const orderedPieces=multiplier*o.multiplier,shopifyQuantity=o.quantityMode==='bundle'?multiplier:orderedPieces;if(!o.inventoryContinues&&o.inventoryQuantity!=null&&shopifyQuantity>o.inventoryQuantity)return null;return{id:o.variantId,quantity:shopifyQuantity}}).filter(Boolean);
const updateButton=()=>{const resolved=Array.from(rows.children).filter(row=>row._item?.matches?.length).length;cartButton.disabled=!resolved||selectedLines().length!==resolved};
const renderRow=(row,auto)=>{const match=row._item?.matches?.[0],select=row.querySelector('select'),product=row.querySelector('.besmart-quick-order__product'),quantityCell=row.querySelector('.besmart-quick-order__quantity-result'),price=row.querySelector('.besmart-quick-order__price'),total=row.querySelector('.besmart-quick-order__total'),multiplier=Math.max(1,parseInt(row.querySelector('.besmart-quick-order__quantity').value,10)||1);if(!match){product.innerHTML='<span class="besmart-quick-order__badge besmart-quick-order__badge--error">'+root.dataset.notFoundLabel+'</span>';select.innerHTML='<option>—</option>';select.disabled=true;quantityCell.textContent=price.textContent=total.textContent='—';updateButton();return}if(!select.dataset.ready){select.replaceChildren();[['pack',root.dataset.packLabel],['carton',root.dataset.cartonLabel]].forEach(([key,label])=>{const o=match.options[key];if(o){const el=document.createElement('option');el.value=key;el.textContent=label+' ('+o.multiplier+' '+root.dataset.piecesLabel+')';select.append(el)}});select.disabled=!select.options.length;select.dataset.ready='true';select.addEventListener('change',()=>renderRow(row,false))}if(auto){const preferred=row.dataset.preferredPackaging;select.value=preferred!=='auto'&&match.options[preferred]?preferred:match.options.pack?'pack':'carton'}const o=selectedOption(row),title=document.createElement('strong'),badge=document.createElement('span');title.textContent=match.productTitle;badge.className='besmart-quick-order__badge'+(o?.available?'':' besmart-quick-order__badge--error');badge.textContent=o?.available?root.dataset.availableLabel:root.dataset.unavailableLabel;product.replaceChildren(title,badge);if(!o){quantityCell.textContent=price.textContent=total.textContent='—';updateButton();return}const orderedPieces=multiplier*o.multiplier,shopifyQuantity=o.quantityMode==='bundle'?multiplier:orderedPieces,short=!o.inventoryContinues&&o.inventoryQuantity!=null&&shopifyQuantity>o.inventoryQuantity;quantityCell.textContent=orderedPieces+' '+root.dataset.piecesLabel;const calculation=document.createElement('small');calculation.textContent=root.dataset.calculationLabel.replace('{multiplier}',multiplier).replace('{packaging}',o.multiplier);quantityCell.append(calculation);if(short){const n=document.createElement('small');n.textContent=root.dataset.stockLabel;quantityCell.append(n);badge.classList.add('besmart-quick-order__badge--error');badge.textContent=root.dataset.unavailableLabel}price.textContent=money(o.price)+' '+root.dataset.vatLabel;total.textContent=money(Number(o.bundlePrice)*multiplier)+' '+root.dataset.vatLabel;updateButton()};
async function lookup(){const list=Array.from(rows.children),codes=list.map(r=>r.querySelector('.besmart-quick-order__code').value.trim());if(!codes.some(Boolean)){status.textContent=root.dataset.emptyLabel;return}status.textContent=root.dataset.lookingLabel;cartButton.disabled=true;cartLink.hidden=true;try{const response=await fetch(root.dataset.endpoint,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({action:'lookup_variants',codes})}),data=await response.json().catch(()=>({}));if(!response.ok)throw new Error(data.error||root.dataset.errorLabel);const map=new Map((data.items||[]).map(item=>[String(item.code).toLocaleLowerCase(),item]));list.forEach((row,i)=>{row._item=map.get(codes[i].toLocaleLowerCase())||{matches:[]};row.querySelector('select').removeAttribute('data-ready');renderRow(row,true)});status.textContent=''}catch(error){status.textContent=error.message||root.dataset.errorLabel}}
const replaceRows=async entries=>{if(!entries.length){status.textContent=root.dataset.emptyLabel;return}rows.replaceChildren();entries.forEach(e=>addRow(e.code,e.quantity,e.packaging));await lookup()};
root.querySelector('[data-quick-order-add-row]').addEventListener('click',()=>addRow());root.querySelector('[data-quick-order-file-button]').addEventListener('click',()=>fileInput.click());fileInput.addEventListener('change',async()=>{const file=fileInput.files?.[0];if(!file)return;status.textContent=root.dataset.uploadingLabel;const form=new FormData();form.append('file',file);try{const response=await fetch(root.dataset.endpoint,{method:'POST',headers:{Accept:'application/json'},body:form}),data=await response.json().catch(()=>({}));if(!response.ok)throw new Error(data.error||root.dataset.errorLabel);await replaceRows(data.entries||[])}catch(error){status.textContent=error.message||root.dataset.errorLabel}finally{fileInput.value=''}});
root.querySelector('[data-quick-order-template]').addEventListener('click',()=>{window.location.assign(root.dataset.templateUrl)});
cartButton.addEventListener('click',async()=>{const grouped=new Map();selectedLines().forEach(x=>grouped.set(String(x.id),(grouped.get(String(x.id))||0)+x.quantity));const items=Array.from(grouped,([id,quantity])=>({id,quantity}));if(!items.length)return;cartButton.disabled=true;status.textContent=root.dataset.lookingLabel;try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items})}),data=await response.json().catch(()=>({}));if(!response.ok)throw new Error(data.description||data.message||root.dataset.errorLabel);status.textContent=root.dataset.addedLabel;cartLink.hidden=false;document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}))}catch(error){status.textContent=error.message||root.dataset.errorLabel}finally{updateButton()}});for(let i=0;i<5;i+=1)addRow()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["besmart-retailer-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = value => String(value || '').trim().toLocaleLowerCase();
    const isItaly = value => ['italia', 'italy', 'it'].includes(normalize(value));

    document.querySelectorAll('[data-besmart-portal]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const endpoint = root.dataset.endpoint;
      const list = root.querySelector('[data-portal-list]');
      const status = root.querySelector('[data-portal-status]');
      const dialog = root.querySelector('[data-portal-dialog]');
      const form = root.querySelector('[data-portal-form]');
      const formStatus = root.querySelector('[data-portal-form-status]');
      const country = form.querySelector('[data-country-select]');
      const italianProvince = form.querySelector('[data-province-select]');
      const otherProvince = form.querySelector('[data-province-input]');
      const italianProvinceWrap = form.querySelector('[data-province-select-wrap]');
      const otherProvinceWrap = form.querySelector('[data-province-input-wrap]');
      let stores = [];
      const labels = {draft: root.dataset.statusDraft, pending: root.dataset.statusPending, approved: root.dataset.statusApproved, rejected: root.dataset.statusRejected, suspended: root.dataset.statusSuspended};
      const request = (method, body) => fetch(endpoint, {method, headers: {Accept: 'application/json', 'Content-Type': 'application/json'}, body: body ? JSON.stringify(body) : undefined}).then(async response => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || root.dataset.error);
        return data;
      });
      const chooseCountry = value => {
        const wanted = normalize(value);
        const option = Array.from(country.options).find(item => normalize(item.value) === wanted || normalize(item.textContent) === wanted || (wanted === 'italia' && normalize(item.value) === 'italy'));
        country.value = option ? option.value : 'Italy';
      };
      const syncProvinceField = () => {
        const italian = isItaly(country.value) || isItaly(country.options[country.selectedIndex]?.textContent);
        italianProvinceWrap.hidden = !italian;
        otherProvinceWrap.hidden = italian;
        italianProvince.disabled = !italian;
        italianProvince.required = italian;
        otherProvince.disabled = italian;
        otherProvince.required = !italian;
      };
      const render = () => {
        list.replaceChildren();
        if (!stores.length) { status.textContent = root.dataset.empty; return; }
        status.textContent = '';
        stores.forEach(store => {
          const card = document.createElement('article');
          card.className = 'besmart-portal__card';
          const h = document.createElement('h3'); h.textContent = store.storeName;
          const badge = document.createElement('span'); badge.className = 'besmart-portal__badge'; badge.textContent = labels[store.workflowStatus] || store.workflowStatus;
          const address = document.createElement('p'); address.textContent = [store.address, store.address2, `${store.postalCode} ${store.city}`, store.province, store.country].filter(Boolean).join(', ');
          const info = document.createElement('p'); info.textContent = store.statusReason || '';
          const actions = document.createElement('div'); actions.className = 'besmart-portal__card-actions';
          const edit = document.createElement('button'); edit.type = 'button'; edit.textContent = root.dataset.edit; edit.addEventListener('click', () => open(store));
          const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = root.dataset.requestRemoval; remove.disabled = store.removalRequested; remove.addEventListener('click', () => { if (!confirm(root.dataset.confirmRemove)) return; request('POST', {action: 'request_removal', id: store.id}).then(load).catch(error => status.textContent = error.message); });
          actions.append(edit, remove); card.append(h, badge, address, info, actions); list.append(card);
        });
      };
      const load = () => { status.textContent = root.dataset.loading; return request('GET').then(data => { stores = Array.isArray(data.locations) ? data.locations : []; render(); }).catch(error => status.textContent = error.message); };
      const open = store => {
        form.reset();
        form.elements.id.value = store?.id || '';
        ['storeName', 'address', 'address2', 'city', 'postalCode', 'publicPhone', 'website', 'instagram', 'facebook', 'tiktok', 'openingHours', 'description'].forEach(name => { form.elements[name].value = store?.[name] || ''; });
        chooseCountry(store?.country || root.dataset.country);
        syncProvinceField();
        if (isItaly(country.value) || isItaly(country.options[country.selectedIndex]?.textContent)) italianProvince.value = store?.province || '';
        else otherProvince.value = store?.province || '';
        form.elements.physicalStoreConfirmed.checked = Boolean(store?.physicalStoreConfirmed);
        form.elements.publicationConsent.checked = Boolean(store?.publicationConsent);
        formStatus.textContent = '';
        dialog.showModal();
      };
      country.addEventListener('change', () => { syncProvinceField(); });
      root.querySelector('[data-portal-new]').addEventListener('click', () => open(null));
      root.querySelectorAll('[data-portal-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      form.addEventListener('submit', event => {
        event.preventDefault();
        const data = Object.fromEntries(new FormData(form));
        data.action = data.id ? 'update' : 'create';
        data.physicalStoreConfirmed = form.elements.physicalStoreConfirmed.checked;
        data.publicationConsent = form.elements.publicationConsent.checked;
        formStatus.textContent = root.dataset.loading;
        request('POST', data).then(() => { dialog.close(); status.textContent = root.dataset.saved; load(); }).catch(error => formStatus.textContent = error.message);
      });
      load();
    });
  })();
  (() => {
    const fill = (field, value) => {
      if (value && (!field.value || field.value === field.dataset.autofilledValue)) {
        field.value = value;
        field.dataset.autofilledValue = value;
      }
    };
    document.querySelectorAll('[data-besmart-portal]').forEach(root => {
      const form = root.querySelector('[data-portal-form]');
      const endpoint = root.dataset.addressLookupEndpoint;
      const country = form?.querySelector('[data-country-select]');
      const province = form?.querySelector('[data-province-select]');
      if (!form || !endpoint || !country || !province) return;
      const lookup = async () => {
        const italian = ['italia', 'italy', 'it'].includes(String(country.value || '').trim().toLocaleLowerCase());
        if (!italian) return;
        const address = form.elements.address?.value?.trim();
        const city = form.elements.city?.value?.trim();
        if (!address || address.length < 3 || !city || city.length < 2) return;
        try {
          const response = await fetch(endpoint, {method: 'POST', headers: {Accept: 'application/json', 'Content-Type': 'application/json'}, body: JSON.stringify({action: 'lookup_address', address, city})});
          if (!response.ok) return;
          const result = await response.json();
          fill(province, result.province);
          fill(form.elements.postalCode, result.postalCode);
        } catch (_error) {}
      };
      ['address', 'city'].forEach(name => form.elements[name]?.addEventListener('blur', lookup));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["besmart-store-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadScript = (src, id) => new Promise((resolve, reject) => {
      const existing = document.getElementById(id);
      if (existing) {
        if (existing.dataset.loaded === 'true') resolve();
        else existing.addEventListener('load', resolve, { once: true });
        return;
      }
      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      script.addEventListener('load', () => { script.dataset.loaded = 'true'; resolve(); }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.append(script);
    });
    const loadGoogleMaps = key => {
      if (window.google?.maps?.importLibrary) return Promise.resolve();
      if (window.__besmartGoogleMapsPromise) return window.__besmartGoogleMapsPromise;
      const callback = `besmartGoogleMapsReady${Date.now()}`;
      window.__besmartGoogleMapsPromise = new Promise((resolve, reject) => {
        window[callback] = () => { delete window[callback]; resolve(); };
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&loading=async&v=weekly&libraries=maps,marker&callback=${callback}`;
        script.async = true;
        script.onerror = reject;
        document.head.append(script);
      });
      return window.__besmartGoogleMapsPromise;
    };
    const text = value => String(value || '');
    const kilometers = (origin, destination) => {
      const radius = 6371;
      const latitude = (destination.latitude - origin.latitude) * Math.PI / 180;
      const longitude = (destination.longitude - origin.longitude) * Math.PI / 180;
      const first = origin.latitude * Math.PI / 180;
      const second = destination.latitude * Math.PI / 180;
      const value = Math.sin(latitude / 2) ** 2 + Math.sin(longitude / 2) ** 2 * Math.cos(first) * Math.cos(second);
      return 2 * radius * Math.asin(Math.sqrt(value));
    };
    document.querySelectorAll('[data-besmart-locator]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const status = root.querySelector('[data-locator-status]');
      const results = root.querySelector('[data-locator-results]');
      const mapElement = root.querySelector('[data-locator-map]');
      const query = root.querySelector('[data-locator-query]');
      const radius = root.querySelector('[data-locator-radius]');
      let stores = [];
      let visibleStores = [];
      let userPosition = null;
      let map = null;
      let infoWindow = null;
      let cluster = null;
      let markerPairs = [];

      const addressText = store => [store.address, store.address2, `${store.postalCode} ${store.city}`, store.province].filter(Boolean).join(', ');
      const directionsUrl = store => {
        const destination = Number.isFinite(store.latitude) && Number.isFinite(store.longitude)
          ? `${store.latitude},${store.longitude}`
          : addressText(store);
        return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
      };
      const popupContent = store => {
        const content = document.createElement('div');
        content.className = 'besmart-map-popup';
        const name = document.createElement('strong');
        name.textContent = text(store.storeName);
        const address = document.createElement('p');
        address.textContent = addressText(store);
        const directions = document.createElement('a');
        directions.href = directionsUrl(store);
        directions.target = '_blank';
        directions.rel = 'noopener';
        directions.textContent = root.dataset.directions;
        content.append(name, address, directions);
        return content;
      };
      const activate = (store, card) => {
        results.querySelectorAll('.is-active').forEach(item => item.classList.remove('is-active'));
        card?.classList.add('is-active');
        const pair = markerPairs.find(item => item.store.id === store.id);
        if (!pair || !map) return;
        map.panTo(pair.marker.position);
        if (map.getZoom() < 13) map.setZoom(13);
        infoWindow.setContent(popupContent(store));
        infoWindow.open({ map, anchor: pair.marker });
      };
      const renderMapMarkers = items => {
        if (!map) return;
        if (cluster) { cluster.clearMarkers(); cluster = null; }
        markerPairs.forEach(item => { item.marker.map = null; });
        markerPairs = [];
        const bounds = new google.maps.LatLngBounds();
        items.forEach(store => {
          if (!Number.isFinite(store.latitude) || !Number.isFinite(store.longitude)) return;
          const marker = new google.maps.marker.AdvancedMarkerElement({
            map: window.markerClusterer ? null : map,
            position: { lat: store.latitude, lng: store.longitude },
            title: text(store.storeName),
            gmpClickable: true,
          });
          marker.addListener('click', () => {
            const card = results.querySelector(`[data-store-id="${CSS.escape(store.id)}"]`);
            activate(store, card);
            card?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          });
          markerPairs.push({ store, marker });
          bounds.extend(marker.position);
        });
        if (window.markerClusterer) {
          cluster = new markerClusterer.MarkerClusterer({ map, markers: markerPairs.map(item => item.marker) });
        }
        if (markerPairs.length > 1) map.fitBounds(bounds, 48);
        if (markerPairs.length === 1) { map.setCenter(markerPairs[0].marker.position); map.setZoom(13); }
      };
      const render = items => {
        visibleStores = items;
        results.replaceChildren();
        status.textContent = items.length ? `${items.length} ${items.length === 1 ? root.dataset.resultOne : root.dataset.resultOther}` : root.dataset.empty;
        items.forEach(store => {
          const card = document.createElement('article');
          card.className = 'besmart-locator__card';
          card.dataset.storeId = store.id;
          card.tabIndex = 0;
          const title = document.createElement('h3');
          title.textContent = text(store.storeName);
          const address = document.createElement('p');
          address.textContent = addressText(store);
          card.append(title, address);
          if (store.distance != null) {
            const distance = document.createElement('p');
            distance.className = 'besmart-locator__distance';
            distance.textContent = `${root.dataset.distance}: ${store.distance.toFixed(1)} km`;
            card.append(distance);
          }
          if (store.openingHours) {
            const hours = document.createElement('p');
            hours.textContent = store.openingHours;
            card.append(hours);
          }
          const links = document.createElement('div');
          links.className = 'besmart-locator__links';
          [[store.publicPhone ? `tel:${store.publicPhone}` : '', store.publicPhone], [store.website, root.dataset.website], [store.instagram, 'Instagram'], [store.facebook, 'Facebook'], [store.tiktok, 'TikTok'], [directionsUrl(store), root.dataset.directions]].forEach(([href, label]) => {
            if (!href || !label) return;
            if (root.dataset.zoopenConsumer === 'true' && /^https?:\/\/(?:www\.)?(?:besmartstore\.it|0c21d9-b1\.myshopify\.com)(?:[/:?#]|$)/i.test(href)) return;
            const link = document.createElement('a');
            link.href = href;
            link.textContent = label;
            if (href.startsWith('http')) { link.target = '_blank'; link.rel = 'noopener'; }
            links.append(link);
          });
          card.append(links);
          card.addEventListener('click', event => { if (!event.target.closest('a')) activate(store, card); });
          card.addEventListener('keydown', event => { if (event.key === 'Enter') activate(store, card); });
          results.append(card);
        });
        renderMapMarkers(items);
      };
      const filter = () => {
        const term = query.value.trim().toLocaleLowerCase();
        let items = stores.filter(store => !term || [store.storeName, store.address, store.address2, store.city, store.province, store.postalCode].some(value => text(value).toLocaleLowerCase().includes(term)));
        if (userPosition) {
          items = items.map(store => ({ ...store, distance: Number.isFinite(store.latitude) && Number.isFinite(store.longitude) ? kilometers(userPosition, store) : null }))
            .filter(store => store.distance != null && store.distance <= Number(radius.value))
            .sort((first, second) => first.distance - second.distance);
        }
        render(items);
      };
      const initializeMap = async () => {
        if (!root.dataset.mapKey) throw new Error('Missing browser key');
        await loadGoogleMaps(root.dataset.mapKey);
        try {
          await loadScript('https://unpkg.com/@googlemaps/markerclusterer@2.6.2/dist/index.min.js', 'besmart-google-marker-clusterer');
        } catch (_error) {
          /* I marker restano utilizzabili anche se il servizio di clustering non è disponibile. */
        }
        await Promise.all([google.maps.importLibrary('maps'), google.maps.importLibrary('marker')]);
        map = new google.maps.Map(mapElement, {
          center: { lat: 42.2, lng: 12.5 },
          zoom: 5.5,
          mapId: root.dataset.mapId || 'DEMO_MAP_ID',
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: true,
          gestureHandling: 'greedy',
        });
        infoWindow = new google.maps.InfoWindow();
        renderMapMarkers(visibleStores);
      };
      root.querySelector('[data-locator-search]').addEventListener('submit', event => { event.preventDefault(); filter(); });
      radius.addEventListener('change', filter);
      root.querySelector('[data-locator-geolocate]').addEventListener('click', () => {
        if (!navigator.geolocation) { status.textContent = root.dataset.error; return; }
        status.textContent = root.dataset.loading;
        navigator.geolocation.getCurrentPosition(value => {
          userPosition = { latitude: value.coords.latitude, longitude: value.coords.longitude };
          filter();
          if (map) map.panTo({ lat: userPosition.latitude, lng: userPosition.longitude });
        }, () => { status.textContent = root.dataset.error; }, { enableHighAccuracy: false, timeout: 10000 });
      });
      const publicEndpoint = new URL(root.dataset.endpoint, window.location.origin);
      publicEndpoint.searchParams.set('_refresh', Date.now().toString());
      fetch(publicEndpoint.toString(), { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(response => { if (!response.ok) throw new Error(); return response.json(); })
        .then(data => { stores = Array.isArray(data.locations) ? data.locations : []; render(stores); })
        .catch(() => { status.textContent = root.dataset.error; });
      initializeMap().catch(() => {
        mapElement.replaceChildren();
        const fallback = document.createElement('p');
        fallback.className = 'besmart-locator__map-fallback';
        fallback.textContent = root.dataset.mapUnavailable;
        mapElement.append(fallback);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoopen-character"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-zoopen-game]').forEach((game) => {
    const feedback = game.parentElement.querySelector('[data-zoopen-feedback]');
    const map = game.parentElement.querySelector('[data-zoopen-map]');
    const celebration = map.querySelector('.zoopen-game__celebration');
    const stars = ['✦', '★', '✧', '✦', '★', '✧', '★', '✦', '✧', '★', '✦', '★'];
    const colors = ['#ffcf37', '#ff6d78', '#7b55e8', '#55c9ff', '#ff9d35', '#74d76a'];
    stars.forEach((star, index) => {
      const sparkle = document.createElement('span');
      const angle = (Math.PI * 2 * index) / stars.length;
      const distance = 85 + (index % 3) * 36;
      sparkle.textContent = star;
      sparkle.style.setProperty('--burst-x', `${Math.cos(angle) * distance}px`);
      sparkle.style.setProperty('--burst-y', `${Math.sin(angle) * distance}px`);
      sparkle.style.setProperty('--star-color', colors[index % colors.length]);
      celebration.appendChild(sparkle);
    });
    const whistle = () => {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return;
      const context = new AudioContextClass();
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(940, context.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(1640, context.currentTime + .16);
      gain.gain.setValueAtTime(.0001, context.currentTime);
      gain.gain.exponentialRampToValueAtTime(.08, context.currentTime + .025);
      gain.gain.exponentialRampToValueAtTime(.0001, context.currentTime + .28);
      oscillator.connect(gain).connect(context.destination);
      oscillator.start();
      oscillator.stop(context.currentTime + .3);
    };
    game.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        game.querySelectorAll('button').forEach((item) => item.classList.remove('is-correct', 'is-wrong'));
        const correct = button.dataset.answer === 'true';
        button.classList.add(correct ? 'is-correct' : 'is-wrong');
        map.classList.toggle('is-solved', correct);
        map.classList.toggle('is-wrong', !correct);
        if (correct) {
          celebration.classList.remove('is-active');
          void celebration.offsetWidth;
          celebration.classList.add('is-active');
          whistle();
        } else {
          celebration.classList.remove('is-active');
        }
        feedback.textContent = correct ? 'Bravissimo! Hai ritrovato la penna! 🖊️' : 'Quasi! Riprova con un’altra scelta.';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
